import type { Dispatch, FC, SetStateAction } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { Heading2 } from "@/ui2/atoms/Heading";
import { ModalControlled2 } from "@/ui2/molecules/Modal";

type CancellationModalProps = {
  isModalOpen: boolean;
  SecondaryCTA: FC;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
};

export function CancellationModal({
  isModalOpen,
  SecondaryCTA,
  setIsModalOpen,
}: CancellationModalProps) {
  return (
    <ModalControlled2 isOpen={isModalOpen} onOpenChange={setIsModalOpen}>
      <div className="tw:flex tw:flex-col tw:gap-6">
        <Heading2 size={2}>Leave without finishing?</Heading2>

        <Divider />

        <p className="body-md tw:text-text-secondary">
          Your progress will be lost if you leave now.
        </p>

        <Divider />

        <div className="tw:flex tw:justify-end tw:gap-x-3">
          <SecondaryCTA />

          <Button2 onPress={() => setIsModalOpen(false)} size="md" variant="primary">
            Continue
          </Button2>
        </div>
      </div>
    </ModalControlled2>
  );
}

function Divider() {
  return (
    <div className="tw:-left-3 tw:h-px tw:w-[calc(100%+(--spacing(12)))] tw:-translate-x-6 tw:bg-stroke-quaternary" />
  );
}
